(ns minorodata.group.model
  (:require [mold.core :as m :refer-macros [defmodel]]
            [minorodata.users.model :refer [searchable-user]]
            [minorodata.transform.model :refer [transform]]))

(declare ->group
         ->unsaved-group
         ->groups-panel
         ->group-transforms)

(defmodel group
  {:id             [::m/string ::m/req ::m/identity "Uniq id"]
   :client-id      [::m/string ::m/req "Client id"]
   :name           [::m/string ::m/nilable "Group name"]
   :description    [::m/string ::m/nilable "Group description"]
   :bulk-scheduled [::m/bool "Is group scheduled"]
   :updated-by     {::m/type     ::m/ref
                    ::m/ref-type searchable-user
                    ::m/doc      "Related user"}
   :created-by     {::m/type     ::m/ref
                    ::m/ref-type searchable-user
                    ::m/doc      "Related user"}
   :updated-at     [::m/string "Timestamp"]
   :created-at     [::m/string "Timestamp"]
   :order          [::m/number ::m/nilable "UI only field to preserve the display order"]
   ;; Schedule
   :schedulable?   [::m/bool "Is this group schedulable"]
   :schedule-tip   [::m/string ::m/nilable "Message for users"]

   :schedule-spec  [::m/map ::m/nilable "{:cron string?}"]})


(defmodel unsaved-group
  {:id          [::m/string ::m/req ::m/identity "Uniq id"]
   :name        [::m/string ::m/nilable "Group name"]
   :description [::m/string ::m/nilable "Group description"]
   ;; Schedule
   :schedule-spec [::m/map ::m/nilable "{:cron string?}"]})


(defmodel groups-panel
  {:groups             {::m/type        ::m/ref
                        ::m/cardinality ::m/many
                        ::m/ref-type    group
                        ::m/doc         "References to the groups for particular page"}
   :active-group       {::m/type     ::m/ref
                        ::m/ref-type group
                        ::m/doc      "Link to the active panel group"}
   :total-pages        [::m/number]
   :page               [::m/number]
   :items-per-page     [::m/number]
   :order-by           [::m/keyword]
   :order-dir          [::m/keyword]
   :latest-order-index [::m/number ::m/nilable]}
  {:singleton true})

(defmodel group-transforms
  {:id  [::m/string ::m/req ::m/identity "Uniq id"]

   :transforms {::m/type        ::m/ref
                ::m/cardinality ::m/many
                ::m/ref-type    transform
                ::m/doc         "Related transforms"}})
